import React from "react";
import { ShieldCheck } from "lucide-react";

export const SatisfactionBadge = ({ className = "", variant = "light" }) => {
  const dark = variant === "dark";
  return (
    <div
      data-testid="satisfaction-badge"
      className={`inline-flex items-start gap-3 rounded-sm border px-4 py-3 ${
        dark ? "bg-white/10 border-white/25 text-white" : "bg-marble-light border-border text-ink"
      } ${className}`}
    >
      <ShieldCheck className={`w-5 h-5 shrink-0 mt-0.5 ${dark ? "text-white" : "text-ink"}`} />
      <div className="text-left">
        <div className="font-heading font-bold text-sm leading-tight">Garantie Satisfaction 24h</div>
        <p className={`text-xs mt-0.5 leading-snug ${dark ? "text-white/70" : "text-muted-foreground"}`}>
          Un point d'insatisfaction ? On revient le corriger sous 24h.
        </p>
      </div>
    </div>
  );
};
